module.exports = __webpack_public_path__ + "static/media/consultor.d11e5c58.svg";